import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { GetTextPipe } from 'src/app/pipes';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { InvAttachedToTypes, InvInventoryGroup } from 'src/models';

@Component({
  selector: 'app-inventory-received-search',
  templateUrl: './inventory-received-search.component.html',
  styleUrls: ['./inventory-received-search.component.css'],
  providers: [GetTextPipe]
})
export class InventoryReceivedSearchComponent implements OnInit {

  //Spinner
  spinnerText: string = "Searching...";
  showSpinner: boolean = false;

  barcode: string;
  inventoryGroupId: number = 0;
  inventoryGroups: Observable<Array<InvInventoryGroup>> = this.transferHttp.getSingle('Inventory/GetInventoryGroups');
  attachedToTypes: Observable<Array<InvAttachedToTypes>> = this.transferHttp.getSingle('Inventory/GetAttachedToTypes');
  owners = this.transferHttp.getSingle('Facilities/GetOwners');
  startDate: Date;
  endDate: Date;


   // AimsCommonTable setup
  header: AimsCommonTableHeader[] = [
    { key: 'inventoryItem.barcode', label: 'Barcode', type: 'number', width: 100, editable: false },
    { key: 'inventoryItem.description', label: 'Description', type: 'string', width: 300, editable: false },
    { key: 'originalQuantity', label: 'Quantity', type: 'number', width: 120 },
    { key: 'inventoryItem.unitOfIssueId', label: 'Unit of Issue', type: 'string', width: 80, editable: false },
    { key: 'ownerId', label: 'Owner', type: 'dynamic',  filterType: 'dynamic', editable: false,
      events: { filterAndSortCompare: (term, el) => term === el.inventoryItem.ownerId } },
    { key: 'receivedDate', label: 'Date Received', type: 'date', editable: false },
    { key: 'costPerUnit', label: 'Cost Per', type: 'dynamic', editable: false },
    { key: 'total', label: 'Tot Cost', type: 'dynamic', editable: false }
  ];
  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: true
  };

  searchCriteria:ReceivedSearchCriteria = new ReceivedSearchCriteria();
  receivedItems: any[] = [];
  private storageName = 'receivedInventorySearch';
  ownerValues = [];

   constructor(private transferHttp: TransferHttpService,
              public getTextPipe: GetTextPipe,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit(): void {
    this.owners.subscribe(o => {
      this.ownerValues = o;
    });

    if (isPlatformBrowser(this.platformId)) {
      const s = window.sessionStorage.getItem(this.storageName);
      if (s !== null) {
        let obj = JSON.parse(s);

        for (let prop in obj) {
          let mom = moment(obj[prop], moment.ISO_8601, true);
          if (mom.isValid()) {
            let date: Date = mom.toDate();
            obj[prop] = date;
          }
        }

        this.searchCriteria = obj;
        this.search();
      }
    }
  }

  public search() {
    if (isPlatformBrowser(this.platformId)) {
      window.sessionStorage.setItem(this.storageName, JSON.stringify(this.searchCriteria));
    }

    this.showSpinner = true;
    this.transferHttp.post(`Inventory/SearchReceivedInventory`, this.searchCriteria).subscribe(retval => {
          this.receivedItems = retval;
          this.showSpinner = false;
        },
        err => { this.showSpinner = false; });
  }

  public clearForm() {
    this.searchCriteria.barcode = null;
    this.searchCriteria.inventoryGroupId = null;
    this.searchCriteria.startDate = null;
    this.searchCriteria.endDate = null;
    this.searchCriteria.ownerId = null;

    if (isPlatformBrowser(this.platformId)) {
      window.sessionStorage.removeItem(this.storageName);
    }
  }

 getDataForExport = (data: any) => {

    var exportData = data.map(eir => {
      return {
        'inventoryItem.barcode': eir.inventoryItem.barcode,
        'inventoryItem.description': eir.inventoryItem.description,
        'originalQuantity': eir.originalQuantity,
        'inventoryItem.unitOfIssueId': eir.inventoryItem.unitOfIssueId,
        'ownerId': this.getTextPipe.transform(eir.inventoryItem.ownerId, 'equipmentOwnerId','equipmentOwner',this.ownerValues),
        'receivedDate': eir.receivedDate,
        'costPerUnit':eir.costPerUnit,
        'total':(eir.costPerUnit * eir.originalQuantity)
      }
    });

    return { 'data': exportData, fileName:"Inventory_Received_Export"  };
  }

}

class ReceivedSearchCriteria {
  barcode: string | null = null;
  inventoryGroupId: number | null = null;
  startDate: Date | null = null;
  endDate: Date| null = null;
  ownerId: number | null = null;
}
